import * as React from 'react';
import {translate} from 'react-i18next';
import {ITranslatedComponent} from '../../../redux/reducers/generalReducer';
import TextField from "../../../components/TextField";
import {Icon, Table} from "semantic-ui-react";
import {compose, Dispatch} from "redux";
import {connect} from "react-redux";
import {FlagDto, ResourceListOfFlagDto} from "../../../services/Client";
import AdminViewActions from "../../../redux/actions/AdminViewActions";
import DeleteButton from "../../../components/DeleteButton";
import TextFlagActionsHeader from "./TextFlagActionsHeader";
import HATEOASClient from "../../../services/HATEOASClient";
import {selectFlags, selectClient} from '../../../redux/selectors';
import {IReduxState} from '../../../redux/IReduxState';

interface IMapDispatchToProps {
    getFlags: () => void;
    createFlag: (links: ResourceListOfFlagDto, dto: FlagDto) => void;
    deleteFlag: (dto: FlagDto) => void;
    updateFlag: (dto: FlagDto) => void;
}

interface IMapStateToProps {
    flags: ResourceListOfFlagDto;
    client: HATEOASClient;
}

interface IOwnProps {

}

interface TextFlagProps extends ITranslatedComponent, IOwnProps, IMapStateToProps, IMapDispatchToProps {
}

interface TextFlagState {
    editMode: boolean;
    showCreationDialog: boolean;
    filterValue?: string;
}

class TextFlag extends React.Component<TextFlagProps, TextFlagState> {
    constructor(props: TextFlagProps) {
        super(props);
        this.state = {
            editMode: false,
            showCreationDialog: false,
            filterValue: undefined,
        };
    }

    componentDidMount() {
        this.props.getFlags();
    }

    public render() {
        const {
            client,
            t,
            flags,
            createFlag,
            getFlags,
            updateFlag,
            deleteFlag
        } = this.props;

        const filteredData = flags.elements && this.state.filterValue
            // @ts-ignore alreacy checked
            ? flags.elements.filter(flag => flag.textLabel.toLowerCase().includes(this.state.filterValue.toLowerCase()))
            : flags.elements;

        return (
            <React.Fragment>
                <TextFlagActionsHeader
                    onExitDialog={(newFlag?: FlagDto) => {
                        this.setState({showCreationDialog: false});
                        if (newFlag) {
                            createFlag(flags, newFlag);
                        }
                    }}
                    openDialog={() => this.setState({showCreationDialog: true})}
                    onEdit={() => this.setState({editMode: !this.state.editMode})}
                    getFlags={getFlags}
                    onFilter={(event: React.FormEvent<{}>, newValue: string) =>
                        this.setState({filterValue: newValue !== "" ? newValue : undefined})}
                    canEdit={filteredData !== undefined && client.PATCH_flag(filteredData[0]).canExecute()}
                    canCreate={client.POST_flag(flags).canExecute()}
                    editMode={this.state.editMode}
                    filterValue={this.state.filterValue}
                    showCreationDialog={this.state.showCreationDialog}
                    t={t}
                />

                <Table celled={true} textAlign="center">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width='10'>{t("TEXT_FLAG:LABEL")}</Table.HeaderCell>
                            <Table.HeaderCell width='2'>{t("TEXT_FLAG:USAGES")}</Table.HeaderCell>
                            <Table.HeaderCell width='3'>{t("TEXT_FLAG:ACTIONS")}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {filteredData && filteredData.length > 0
                            ?
                            filteredData.map(flag =>
                                <Table.Row key={flag.objectId}>
                                    <Table.Cell width='10' textAlign="left">
                                        <TextField
                                            id={flag.textLabel}
                                            disabled={!this.state.editMode}
                                            shouldAlwaysUpdate={true}
                                            maxLength={32}
                                            value={flag.textLabel}
                                            onBlur={(e: any, value: string) => {
                                                if (flag.textLabel !== value) {
                                                    let newDto: FlagDto = flag;
                                                    newDto.textLabel = value.trim();
                                                    updateFlag(newDto);
                                                }
                                            }}
                                        />
                                    </Table.Cell>
                                    <Table.Cell width='2'>
                                        {flag.optionsCount
                                            ? <> {flag.optionsCount} <Icon name='tags' /> </>
                                            : 0
                                        }
                                    </Table.Cell>
                                    <Table.Cell width='3'>
                                        {client.DELETE_flag(flag).canExecute()
                                            ?
                                            <DeleteButton
                                                label={t("TEXT_FLAG:DELETE_FLAG")}
                                                confirmLabel={t("GLOBAL:CONFIRM")}
                                                requireConfirmation={true}
                                                onClick={() => deleteFlag(flag)}
                                            />
                                            :
                                            t('TEXT_FLAG:NO_RIGHTS')
                                        }
                                    </Table.Cell>
                                </Table.Row>
                            )
                            :
                            <Table.Row>
                                <Table.Cell colSpan='3' style={{fontWeight: 700, fontSize: 30, color: '#d3d3d3'}}>
                                    {t('GLOBAL:NO_DATA')}
                                </Table.Cell>
                            </Table.Row>
                        }
                    </Table.Body>
                </Table>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    flags: selectFlags(state),
    client: selectClient(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: TextFlagProps): IMapDispatchToProps => ({
    getFlags: () => dispatch(AdminViewActions.GetTextFlags(ownProps.t)),
    createFlag: (links: ResourceListOfFlagDto, dto: FlagDto) => dispatch(AdminViewActions.CreateTextFlag(ownProps.t, links, dto)),
    deleteFlag: (dto: FlagDto) => dispatch(AdminViewActions.DeleteTextFlag(ownProps.t, dto)),
    updateFlag: (dto: FlagDto) => dispatch(AdminViewActions.UpdateTextFlag(ownProps.t, dto)),
});

export default compose<React.ComponentType<IOwnProps>>(
    translate(["GLOBAL", "TEXT_FLAG"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(TextFlag);



// WEBPACK FOOTER //
// ./src/views/AdminView/FlagTab/TextFlag.tsx